import { EThemes } from '@/lib/contentstack-sdk/types';
import { OrMiniCtaBlockC } from './or-mini-cta-block-c';
import {
  parseGlobalLinkFromCMS,
  parseImageFromCMS,
} from '@/lib/contentstack-sdk/utils/parseHelpers';
import { RenderRichText } from '@/components/helpers/cms/RenderRichText';
import { IMiniCtaBlockCPropsCS } from './or-mini-cta-block-c.types';
import { SizesProvider } from '@/state/sizesProvider';

export const OrMiniCtaBlockCCS = ({ block }: IMiniCtaBlockCPropsCS) => {
  const {
    content_title,
    cta,
    description,
    theme: { theme },
    image,
    title_element,
    title_variant,
    top_spacing,
    bottom_spacing,
    lead_gen_form,
    _content_type_uid: contentType,
  } = block;
  const ctaProps = parseGlobalLinkFromCMS(cta, 'or-mini-cta-block-c');

  return (
    <SizesProvider contentType={contentType}>
      <OrMiniCtaBlockC
        cta={ctaProps}
        content_title={content_title}
        theme={EThemes[theme]}
        image={image ? parseImageFromCMS(image) : undefined}
        title_element={title_element}
        title_variant={title_variant}
        topSpacing={top_spacing?.spacing_value}
        bottomSpacing={bottom_spacing?.spacing_value}
        topDivider={top_spacing?.divider}
        bottomDivider={bottom_spacing?.divider}
        leadGenForm={lead_gen_form?.[0]}
      >
        {description && <RenderRichText body={description} />}
      </OrMiniCtaBlockC>
    </SizesProvider>
  );
};
